// src/components/transfers/PayDialog.jsx
import React, { useState } from 'react';
import { X } from 'lucide-react';

const PayDialog = ({ transferNo, defaultAmount, onClose, onPay }) => {
  const [paidAmount, setPaidAmount] = useState(defaultAmount || '');
  const [notes, setNotes] = useState('');
  const [paying, setPaying] = useState(false);

  const handleSubmit = async () => {
    if (!paidAmount) { alert('请输入付款金额'); return; }
    setPaying(true);
    try {
      await onPay(transferNo, { paid_amount: parseFloat(paidAmount), notes });
    } finally {
      setPaying(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md">
        <div className="p-6 border-b flex justify-between items-center">
          <h3 className="text-lg font-bold">提交付款通知</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600"><X className="w-6 h-6" /></button>
        </div>
        <div className="p-6 space-y-4">
          <div className="bg-orange-50 border border-orange-200 rounded-lg px-4 py-3 text-sm text-orange-700">
            填写实际付款金额，通知总店核对收款
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">付款金额 *</label>
            <input type="number" min="0" step="0.01" value={paidAmount}
              onChange={e => setPaidAmount(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg" placeholder="0.00" />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">付款备注</label>
            <textarea value={notes} onChange={e => setNotes(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg text-sm" rows={2}
              placeholder="如：已转账至KHQR，凭证截图已发微信（可选）" />
          </div>
        </div>
        <div className="p-6 border-t flex space-x-3">
          <button onClick={onClose} className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">取消</button>
          <button onClick={handleSubmit} disabled={paying}
            className={`flex-1 px-4 py-2 bg-orange-500 text-white rounded-lg ${paying ? 'opacity-50 cursor-not-allowed' : 'hover:bg-orange-600'}`}>
            {paying ? '提交中...' : '提交付款通知'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PayDialog;
